import { render } from "./Permissions.vue?vue&type=template&id=c3a7ecc2"
import script from "./Permissions.vue?vue&type=script&lang=js"
export * from "./Permissions.vue?vue&type=script&lang=js"

import "./Permissions.vue?vue&type=style&index=0&id=c3a7ecc2&lang=less"

import exportComponent from "/codebuild/output/src3271881597/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__